import { render } from "./record.vue?vue&type=template&id=5680fc61&scoped=true&ts=true"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"

import "./record.vue?vue&type=style&index=0&id=5680fc61&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5680fc61"]])

export default __exports__